import { render, staticRenderFns } from "./InstitutionDialog.vue?vue&type=template&id=792ef402"
import script from "./InstitutionDialog.vue?vue&type=script&lang=js"
export * from "./InstitutionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports